import { render } from "./InputViewLink.vue?vue&type=template&id=274c1042&scoped=true"
import script from "./InputViewLink.vue?vue&type=script&lang=js"
export * from "./InputViewLink.vue?vue&type=script&lang=js"

import "./InputViewLink.vue?vue&type=style&index=0&id=274c1042&scoped=true&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274c1042"]])

export default __exports__